import Daily_actions_controller from "../daily_actions_controller";
import MicroModal from "micromodal";

export default class extends Daily_actions_controller {}
